import styled from 'styled-components';

export const Wrapper = styled.div`
  user-select: none;
  position: relative;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 327px;
  };
`;
